import React, {useEffect, useState} from "react";
import {Col, Row, Card} from "antd";
import api from '@api/discount-code'
import Search from '@components/discountCodes/item/StatisticsReport/Search';
import Chart from '@components/discountCodes/item/StatisticsReport/Chart';
import List from '@components/discountCodes/item/StatisticsReport/List';
import whitListData from '@hocs/withListData';
import withPaginationComponent from '@hocs/withPaginationComponent';


function DiscountCodeStatistics(props) {
  const {data, isFetched, currentPage, search} = props;
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <Search search={search}/>
        </Card>
      </Col>
      <Col span={24} className={"page-table-wrapper"}>
        {data.length > 0 && <Chart data={data}/>}
    
        <List
          loading={!isFetched}
          currentPage={currentPage}
          data={data}/>
      </Col>
    </Row>
  )
}



export default whitListData(
  withPaginationComponent(DiscountCodeStatistics),
  {
    fetchRequest: api.getItemStatistics,
    paginationOnScroll: false
  }
);